<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="dmv-search-results inner-home">
    <div class="container">
      <div class="row no-margin">
        <!--heading section starts here-->
         <div class="col-6 col-sm-2 mt-4">
          <!-- <a  href="javascript:void(0)" (click)="goBack()">
            <i class="fa fa-chevron-left arrow-left"></i>
            <span class="backTxt">Back</span>
          </a> -->
        </div> 
  
        <div class="col-12 col-sm-8 mt-4">
          <div id="searchResu">Please Review Your Cart</div>
    
        </div>
  
  
         <div class="col-6 col-sm-2 icon-cart mt-4">
        <!--dmv-shoping-cart [donation]="dmvStoreService?.registrationsInCart?.donation" [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations"></dmv-shoping-cart-->
        </div>
  
        <!--heading section ends here-->
        <div class="alert alert-info" *ngIf="userStoreService?.getUserProfile()?.megUserGUID &&  isAnyResNotExistInProfile">
            &nbsp;<span [innerHTML]="transformMessage((megStoreService.configurationsData$ | async)?.megConfig?.newBillingAccountText)"></span>
          </div>
          
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
        <div class="col-12 col-sm-12 col-md-12" style="padding:0px">

          <div class="p-r" id="rectangle" *ngFor="let dmvRegistration of dmvStoreService?.registrationsInCart?.dmvRegistrations; let i = index">
                <div class="row no-margin pt-3 pb-2">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">{{(dmvRegistration?.registration?.availableRenewalOptions && dmvRegistration?.registration?.availableRenewalOptions?.length>0 && dmvRegistration?.selectedRenewalOption)?dmvRegistration?.registration?.availableRenewalOptions[dmvRegistration?.selectedRenewalOption-1].name:''}}
                    {{(dmvRegistration?.registration?.availableRenewalOptions && dmvRegistration?.registration?.availableRenewalOptions?.length>0  && dmvRegistration?.isPlateChange)?" & ":""}}{{(dmvRegistration?.isPlateChange)?"Plate Change":""}}
                    </div>
                    <div class="col-12 col-sm-9">
                        <div class="rectangle-wrapper">
                                <div id="pin">pin:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistration?.registration?.pinNumber}}</div>

                                <div id="pin">plate:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistration?.registration?.licensePlate}}</div>
                        </div>
                        <div class="addprofile-wrapper" *ngIf="userStoreService?.getUserProfile()?.megUserGUID && !profileMap.get(dmvRegistration?.registration?.registrationID)?.inInProfile">
                            <div class="addprofile">
                                <button [ngClass]="{'disabled': profileMap.get(dmvRegistration?.registration?.registrationID)?.isDisbled}" class="btn btn-primary btn-add-item btn-add-to-profile" (click)="addToProfile(dmvRegistration?.registration)">Add to Profile</button>
                                <div class="addprofile-message-success {{profileMap.get(dmvRegistration?.registration?.registrationID)?.type}}" >{{profileMap.get(dmvRegistration?.registration?.registrationID)?.text || 'Adding a registration to your profile will simplify future renewals.'}}</div>
                                
                            </div>
                            <!-- <div class="addprofile-message-success" *ngIf="profileMap.get(dmvRegistration?.registration?.registrationID)?.type==='success'">Saved to profile.</div> -->
                            <!-- <div class="addprofile-message-fail" *ngIf="profileMap.get(dmvRegistration?.registration?.registrationID)?.type==='fail'">Sorry, it did not work.</div> -->
                         </div>

                        <div class="rectangle-wrapper">
                                <div id="pin">make:</div>
                                <div class="merc-number">{{dmvRegistration?.registration?.makeModel}}</div>   
                        </div>                       
                    </div>
                    
                    <div class="col-12 col-sm-3">
                        <div class="amounTxt">Amount:</div>
                        <div class="amount-rupees">{{dmvRegistration?.registration?.totalAmountDue | number : '1.2-2'  | currency | minusSignToParens}}</div>
                    </div>
                    <div class="close-icon">
                        <img src="{{globalService.staticResourceURL}}/assets/images/Icon-icon-placeholder.svg" (click)="removeRegistration(dmvRegistration, i)" class="img-fluid">
                    </div>
                    <div class="edit-icon">
                          <i class="icon-group-10" (click)="editRegistration(i, $event)"> <svg-image   [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>
                    </div>
                  
                </div>
            </div>



            <div class="p-r" id="rectangle" *ngFor="let dmvRegistrationManual of dmvStoreService?.registrationsInCart?.dmvRegistrationsManual; let i = index">
                <div class="row no-margin pt-3 pb-2">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Manual Registration
</div>
                    <div class="col-12 col-sm-9">
                        <div class="rectangle-wrapper">
                                

                                <div id="pin">tag Number:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistrationManual?.tagNumber}}</div>
                        </div>
                                            
                    </div>
                    
                    <div class="col-12 col-sm-3">
                        <div class="amounTxt">Amount:</div>
                        <div class="amount-rupees">{{(dmvRegistrationManual?.amount + dmvRegistrationManual?.lateFee) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>
                    <div class="close-icon">
                        <img src="{{globalService.staticResourceURL}}/assets/images/Icon-icon-placeholder.svg" (click)="removeManualRenew(dmvRegistrationManual)" class="img-fluid">
                    </div>
                    <div class="edit-icon">
                         <i class="icon-group-10" (click)="editManualRenew(i, $event)"> <svg-image   [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>
                      
                    </div>
                  
                </div>
            </div>

            <div class="p-r" id="rectangle" *ngFor="let dmvRegistrationDuplicate of dmvStoreService?.registrationsInCart?.dmvRegistrationsDuplicate; let i = index">
                <div class="row no-margin pt-3 pb-2">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Duplicate Registration
</div>
                    <div class="col-12 col-sm-9">
                        <div class="rectangle-wrapper">
                                

                                <div id="pin">tag Number:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistrationDuplicate?.tagNumber}}</div>
                        </div>
                                            
                    </div>
                    
                    <div class="col-12 col-sm-3">
                        <div class="amounTxt">Amount:</div>
                        <div class="amount-rupees">{{(dmvRegistrationDuplicate?.dmvCostData?.totalAmountDue) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>
                    <div class="close-icon">
                        <img src="{{globalService.staticResourceURL}}/assets/images/Icon-icon-placeholder.svg" (click)="removeDuplicate(dmvRegistrationDuplicate)" class="img-fluid">
                    </div>
                    <div class="edit-icon">
                         <i class="icon-group-10" (click)="editDuplicate(i, $event)"> <svg-image   [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>
                      
                    </div>
                  
                </div>
            </div>

            <div class="p-r" id="rectangle" *ngIf="dmvStoreService?.registrationsInCart?.donation">
                <div class="row no-margin pt-3 pb-2">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Donation</div>
                    <div class="col-12 col-sm-9">
                        <div class="rectangle-wrapper">
                                <div id="pin">Charity:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvStoreService?.registrationsInCart?.donation?.name}}</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="amounTxt">Amount:</div>
                        <div class="amount-rupees">{{dmvStoreService?.registrationsInCart?.donation?.amount | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>

                    <div class="close-icon">
                        <img src="{{globalService.staticResourceURL}}/assets/images/Icon-icon-placeholder.svg" (click)="removeDonation()"  class="img-fluid">
                    </div>
                    <div class="edit-icon">
                         <i class="icon-group-10" (click)="editDonation($event)"> <svg-image   [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>
                       
                  
                    </div>
                </div>
            </div>



            <div class="p-r" id="rectangle"  *ngIf="dmvStoreService?.registrationsInCart?.pickupInPerson">
                <div class="row no-margin pt-3 pb-2">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">{{globalService.supportKioskPickup?'Pickup from Kiosk':'In-Person Pickup'}}</div>
                    <div class="col-12 col-sm-12" *ngIf="!globalService.supportKioskPickup">
                        <div class="rectangle-wrapper">
                                <div id="pin" class="lh21">Location:<br/>&nbsp;</div>
                                <div id="pin-number" class="pin-sm-number lh21">{{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.line1}} {{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.line2}}
                                
                                  <br/>{{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.city}}, {{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.stateCode}} {{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.postalCode}}
                                </div>

                        </div>
                        <div *ngIf="dmvStoreService?.registrationsInCart?.pickupInPerson?.authorizedPerson" class="rectangle-wrapper">
                                <div id="pin">Name:</div>
                                <div class="merc-number">{{dmvStoreService?.registrationsInCart?.pickupInPerson?.authorizedPerson}}</div>   
                        </div>
                    </div>
                    <div class="col-12 col-sm-12" *ngIf="globalService.supportKioskPickup ">
                        
                        <div class="rectangle-wrapper pin-sm-number">{{notifyTo}}</div>  
                    </div>
                   

                    <div class="edit-icon">
                          <i class="icon-group-10" (click)="editPickupInPerson($event)" > <svg-image   [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>

                    </div>
                </div>
            </div>


             <div class="p-r" id="rectangle"  *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress">
                <div class="row no-margin pt-3 pb-2">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Mail Documents To</div>
                   
                        
                             <div class="col-12 col-sm-9">
                                 <div class="rectangle-wrapper locationBox">
                                        <div id="pin" class="lh21">Location:<br/>&nbsp;</div>
                                        <div id="pin-number"  class="pin-sm-number lh21" *ngIf="dmvStoreService?.registrationsInCart?.hasAddress">{{dmvStoreService?.registrationsInCart?.mailingAddress?.billigAddress1}} {{dmvStoreService?.registrationsInCart?.mailingAddress?.billigAddress2}}<br/>{{dmvStoreService?.registrationsInCart?.mailingAddress?.city}}, {{dmvStoreService?.registrationsInCart?.mailingAddress?.state}} {{dmvStoreService?.registrationsInCart?.mailingAddress?.zip}}<br/>
                                            {{dmvStoreService?.registrationsInCart?.mailingAddress?.countryCode !== 'US'?countryName:''}}
                                        </div>

                                        
                                        <div id="pin-number"  class="pin-sm-number pr-4 lh21" *ngIf="!dmvStoreService?.registrationsInCart?.hasAddress">{{dmvStoreService.registrationsInCart?.mailingText}}
                                        </div>
                                      

                                </div>
                                <div class="rectangle-wrapper" *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress?.registrantName">
                                        <div id="pin">Name:</div>
                                        <div class="merc-number">{{dmvStoreService?.registrationsInCart?.mailingAddress?.registrantName}}</div>   
                                </div>

                                <div  *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress?.permAddressUpdate  && dmvStoreService?.registrationsInCart?.dmvRegistrations?.length" class="rectangle-wrapper">
                                    <div >{{ dmvStoreService?.agencyConfig?.agencyDmvConfig?.permAddressUpdateNote}}</div>
                                </div>
                                <div  *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress?.tempAddressChange  && dmvStoreService?.registrationsInCart?.dmvRegistrations?.length" class="rectangle-wrapper">
                                    <div class="review-page-mailing-info">{{ dmvStoreService?.agencyConfig?.agencyDmvConfig?.tempAddressChangeNote}}</div>
                                </div>
                             </div>
                    
                    <div class="col-12 col-sm-3" *ngIf="IsmailFee">
                        <div class="amounTxt">Amount:</div>
                        <div class="amount-rupees">{{mailFee | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>

                    <div class="edit-icon" *ngIf="dmvStoreService?.agencyConfig?.agencyDmvConfig?.allowAddressUpdate || dmvStoreService?.agencyConfig?.agencyDmvConfig?.allowMailingToTempAddress || dmvStoreService?.agencyConfig?.agencyDmvConfig?.allowPickup">
                         <i class="icon-group-10"  (click)="editMailingAddress($event)"> <svg-image  [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig.primaryColor" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>
                       
                    </div>
                </div>  
            </div>

        </div>
      
       
          

        
              
         
      </div>

      <div class="m-auto text-center">
                    <a >
                        <button class="btn btn-primary btn-add-item" (click)="addAnotherItem()"><i class="fa fa-plus"></i> Add Another Item </button>
                    </a>                    
                    
                    <a >
                        <button class="btn btn-primary btn-continue" (click)="continue()">Continue <i class="fa fa-chevron-right text-right"></i></button>
                    </a>
                </div>
     </div>
  </div>

 
  <dmv-login-popup-model *ngIf="openloginModel && !userStoreService?.getUserProfile()?.megUserGUID && userStoreService.loginPopupRequest && (megStoreService.configurationsData$ | async)?.megConfig?.enableUserRegistration" (noThanks)="noThanks()" (logIn)="logIn()" (register)="register()"></dmv-login-popup-model>
  <dmv-renewal-reminders-model *ngIf="openRennewalReminderModel" (yesConfirm)="yes()" (noConfirm)="no()"></dmv-renewal-reminders-model>